import React, { Component } from "react";
import { RouteComponentProps } from "react-router";
import Datatable from "../../Constants/Datatable";
import { COLUMNS_TEACHERS } from "../../Constants/DatatableColumns";
import { validateTokenStorage } from "./../../Constants/Util";
import { PENCIL } from "../../Constants/SrcImages";
import { Row, Col, Label, Container, ButtonGroup, Button } from "reactstrap";
import { getConsejeria, putChangeSchedule, putLink } from "../../Constants/Services";
import { ITeachers } from "./../../Constants/Interfaces";
import StoreContext from "./../../../Store/Context";
import { ModalLinkPersonal } from "./../../Constants/Modal";
import ClipLoader from "react-spinners/ClipLoader";
import { css } from "@emotion/core";

const override = css`
  margin: 0 auto;
  position: relative;
  top: 10px;
  right: 10px;
`;

interface ITeacherState {
  dataTeachers: ITeachers[];
  loading: boolean;
  isOpenLinkPersonalEdit: boolean;
  dataFPerson: {
    per_id: string;
    per_link: string;
    per_name: string;
  };
  msg_error: string;
}

class Teachers extends Component<RouteComponentProps<{}>, ITeacherState> {
  static contextType = StoreContext;
  constructor(props: any) {
    super(props);
    this.state = {
      dataTeachers: [],
      loading: false,
      dataFPerson: {
        per_id: "",
        per_link: "",
        per_name: "",
      },
      isOpenLinkPersonalEdit: false,
      msg_error: "",
    };

    this.fetchTeacher = this.fetchTeacher.bind(this);
    this.rechargeData = this.rechargeData.bind(this);
    this.handleChangeSchedule = this.handleChangeSchedule.bind(this);
    this.onChangeTeacher = this.onChangeTeacher.bind(this);
    this.handleModalEditLink = this.handleModalEditLink.bind(this);
    this.handlerPutTeacherLink = this.handlerPutTeacherLink.bind(this);
    this.handleModalCloseEditModal = this.handleModalCloseEditModal.bind(this);
    this.handlerEditLink = this.handlerEditLink.bind(this);
  }

  async fetchTeacher() {
    const response = await getConsejeria();
    var teacher = [];
    var hashTeacher = {};
    // teacher = response.filter((o) => (hashTeacher[o.per_id] || o.per_id === null ? false : (hashTeacher[o.per_id] = true)));
    teacher = response.filter((o) => (hashTeacher[o.per_id] || o.per_id === null ? false : (hashTeacher[o.per_id] = true)));

    this.setState({
      dataTeachers: teacher,
      loading: false,
      msg_error: "",
    });
  }

  componentDidMount() {
    if (validateTokenStorage()) {
      this.context.quitToken();
    }
    this.fetchTeacher();
  }

  rechargeData() {
    this.setState({ loading: true });
    setTimeout(() => {
      this.fetchTeacher();
    }, 1000);
  }

  handleIntoTeachers(row) {
    this.context.setToken({ token: true, usr_type: "/teachers", per_id: row.per_id, year: this.context.year, allow: true, per_admin: this.context.per_id });
  }

  handlerInto = (cell, row) => (
    <Row>
      <Col sm={12}>
        <Button color="success" className="w-100" onClick={() => this.handleIntoTeachers(row)}>
          Entrar
        </Button>
      </Col>
    </Row>
  );

  handleChangeSchedule(row: any) {
    const body = {
      per_id: row.per_id,
      per_changeSchedule: row.per_changeSchedule,
    };
    this.setState({ loading: true });
    putChangeSchedule(body);
    setTimeout(() => {
      this.fetchTeacher();
    }, 1000);
  }

  handlerChange = (cell: string, row: any) => {
    return (
      <Row>
        <Col sm={12} className="text-center m-auto">
          <ButtonGroup>
            <Button outline onClick={() => this.handleChangeSchedule(row)} active={row.per_changeSchedule === "1" ? true : false}>
              SI
            </Button>
            <Button outline onClick={() => this.handleChangeSchedule(row)} active={row.per_changeSchedule === "0" ? true : false}>
              NO
            </Button>
          </ButtonGroup>
        </Col>
      </Row>
    );
  };

  onChangeTeacher(e: any) {
    this.setState({
      dataFPerson: {
        ...this.state.dataFPerson,
        [e.target.name]: e.target.value,
      },
      msg_error: "",
    });
  }

  handleModalEditLink(row: any) {
    this.setState((prevState) => ({
      isOpenLinkPersonalEdit: true,
      dataFPerson: {
        per_id: row.per_id,
        per_link: row.per_link,
        per_name: `${row.per_name} (${row.per_lastname})`,
      },
      msg_error: "",
    }));
  }

  handleModalCloseEditModal() {
    this.setState((prevState) => ({
      isOpenLinkPersonalEdit: !prevState.isOpenLinkPersonalEdit,
      dataFPerson: {
        per_id: "",
        per_link: "",
        per_name: "",
      },
      msg_error: "",
    }));
  }
  
  handlerPutTeacherLink() {
    const props = this.state.dataFPerson;
    const body = {
      per_id: props.per_id,
      per_link: props.per_link,
    };
    if (props.per_link !== null) {
      if (props.per_link.length > 0) {
        putLink(body);
        this.setState({ isOpenLinkPersonalEdit: false, msg_error: "" });
        setTimeout(() => {
          this.fetchTeacher();
        }, 1000);
      } else {
        this.setState({ msg_error: "Algunos campos estan vacios" });
      }
    } else {
      this.setState({ msg_error: "Algunos campos estan vacios" });
    }
  }

  handlerEditLink = (cell: any, row: any) => (
    <React.Fragment>
      <Row>
        <Col xs={12} className="d-flex">
          <Label className="txt-underline" onClick={() => this.handleModalEditLink(row)}>
            {row.per_link}
          </Label>
          <img className="img-status img-search" onClick={() => this.handleModalEditLink(row)} src={PENCIL} alt="" />
        </Col>
      </Row>
    </React.Fragment>
  );

  render() {
    const props = this.state;
    return (
      <React.Fragment>
        {props.isOpenLinkPersonalEdit && (
          <ModalLinkPersonal
            title="Link personal"
            onChange={this.onChangeTeacher}
            isOpen={props.isOpenLinkPersonalEdit}
            toggle={this.handleModalCloseEditModal}
            toggleSave={this.handlerPutTeacherLink}
            dataFTeacher={props.dataFPerson}
            msg_error={props.msg_error}
          />
        )}
        <Container className="mt-4">
          <Row>
            <Col sm={12}>
              <Row>
                <Col sm={12} className="text-center">
                  <h3>Profesores</h3>
                </Col>
                <Col sm={12} className="text-right">
                  <ClipLoader css={override} size={23} color={"#36D7B7"} loading={this.state.loading} />
                  <Button color="primary" onClick={() => this.rechargeData()}>
                    Recargar
                  </Button>
                </Col>
                <Col sm={12}>
                  <Datatable
                    data={props.dataTeachers}
                    columns={COLUMNS_TEACHERS(this.handlerInto, this.handlerChange, this.handlerEditLink)}
                    keyProp="per_id"
                    exportD={false}
                    searchs={true}
                    selectRows={false}
                    optionSelectRow={null}
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default Teachers;
